import { EndpointsContract } from '@terra/shared-contracts-endpoints';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const endpointsClient = createTerraOrpcClient({
  contract: EndpointsContract,
  serviceName: SERVICE_NAME,
});
